
export type Vector = { x: number, y: number };

export function scale(v: Vector, s: number) {
  return { x: v.x * s, y: v.y * s };
}
